import { CollectedPreviewItem } from "@apiserver-rest/ponder-data-client-base";
import { FilteredPreviewItem } from "./filtered-preview-item";
import { PreviewItemFilters } from "./preview-item-filters";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { CollectionModifiedEvent } from "@ponder-core/events/collection.events";

/**
 * Container for one or more {@link FilteredPreviewItem}s.
 */
export class FilteredPreviewItems {
    public items!: FilteredPreviewItem[];
    public visibleItems!: FilteredPreviewItem[];
    
    public count: number = 0;
    public value: number = 0;
    public specialValue: number = 0;
    public collectedCount: number = 0;
    public collectedValue: number = 0;
    public distinctCollectedCount: number = 0;

    public visibleCount: number = 0;
    public visibleValue: number = 0;
    public visibleSpecialValue: number = 0;
    public visibleCollectedCount: number = 0;
    public visibleCollectedValue: number = 0;
    public visibleCollectedSpecialValue: number = 0;
    public visibleDistinctCollectedCount: number = 0;

    private lastFilters?: PreviewItemFilters;

    public constructor(previewItems: CollectedPreviewItem[], private events: EventBroker) {
        this.items = previewItems.map((previewItem: CollectedPreviewItem, index: number) => {
            this.value += previewItem.price.normalUSD;
            this.specialValue += previewItem.price.specialUSD;

            if (previewItem.collected?.count) {
                this.collectedCount += previewItem.collected!.count;
                this.collectedValue += previewItem.collected!.count * previewItem.price.normalUSD;
            }

            if (previewItem.collected?.specialCount) {
                this.collectedCount += previewItem.collected!.specialCount;
                this.collectedValue += previewItem.collected!.specialCount * previewItem.price.specialUSD;
            }

            if (previewItem.collected?.proxyCount) {
                this.collectedCount += previewItem.collected!.proxyCount;
            }

            this.distinctCollectedCount += (previewItem?.collected?.count || previewItem.collected?.specialCount || previewItem?.collected?.proxyCount) ? 1 : 0;

            return new FilteredPreviewItem(previewItem, index)
        });

        this.count = this.items.length;
    }

    public addItem(item: CollectedPreviewItem) {
        this.items.push(new FilteredPreviewItem(item, -1));
    }

    public removeItem(item: CollectedPreviewItem) {
        var index = this.items.findIndex(i => i.previewItem.item.id! === item.item.id!);

        if (index >= 0) {
            this.items.splice(index, 1);
        }
    }

    public populate(filters?: PreviewItemFilters | undefined) {
        filters = filters ?? this.lastFilters;
        this.lastFilters = filters;
        
        filters?.sort(this.items);

        this.visibleItems = [];
        this.visibleValue = 0;
        this.visibleSpecialValue = 0;
        this.visibleCollectedCount = 0;
        this.visibleCollectedValue = 0;
        this.visibleCollectedSpecialValue = 0;
        this.distinctCollectedCount = 0;
        this.visibleDistinctCollectedCount = 0;

        this.items.forEach((item: FilteredPreviewItem, index: number) => {
            item.isVisible = filters?.isVisible(item) ?? true;
            item.currentIndex = index;

            if (item.isVisible) {
                this.trackVisible(item);
            }
        });

        filters?.postVisibleCheck();

        this.visibleCount = this.visibleItems.length;

        this.events.ui.itemVisibilityRecalculatedEvent.emit();
    }

    private trackVisible(item: FilteredPreviewItem): void {
        this.visibleItems.push(item);
        this.visibleValue += item.previewItem.price.normalUSD;
        this.visibleSpecialValue += item.previewItem.price.specialUSD;

        if (item.previewItem.collected?.count) {
            this.visibleCollectedCount += item.previewItem.collected!.count;
            this.visibleCollectedValue += item.previewItem.collected!.count * item.previewItem.price.normalUSD;
        }

        if (item.previewItem.collected?.specialCount) {
            this.visibleCollectedCount += item.previewItem.collected!.specialCount;
            this.visibleCollectedSpecialValue += item.previewItem.collected!.specialCount * item.previewItem.price.specialUSD;
        }

        if (item.previewItem.collected?.proxyCount) {
            this.visibleCollectedCount += item.previewItem.collected!.proxyCount;
        }
        
        this.visibleDistinctCollectedCount += (item.previewItem.collected?.count || item.previewItem.collected?.specialCount || item.previewItem.collected?.proxyCount) ? 1 : 0;
    }

    public onCollectionModified(event: CollectionModifiedEvent): void {
        for (let i = 0; i < this.visibleItems.length; ++i) {
            let pItem = this.visibleItems[i].previewItem;

            if (pItem.item.id! === event.itemId) {
                if (event.newToCollection) {
                    this.visibleDistinctCollectedCount++;
                } else if (event.removedFromCollection) {
                    this.visibleDistinctCollectedCount--;
                }

                this.visibleCollectedCount += event.countAdjustment + event.specialCountAdjustment + event.proxyCountAdjustment;
                this.visibleCollectedValue += (event.countAdjustment * pItem.price.normalUSD) + (event.specialCountAdjustment * pItem.price.specialUSD);
                
                // todo ... update current filter ...

                break;
            }
        }
    }

    public getCurrentIndex(item: CollectedPreviewItem): number {
        var sortedItem = this.items.find(filteredItem => filteredItem.previewItem === item);
        return sortedItem?.currentIndex ?? -1;
    }
}